import { SVGProps } from "react"

export const ReplyIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			transform="scale(1.6)"
			d="M0.162283 3.17081L3.59986 0.11754C3.90076 -0.149747 4.375 0.0672368 4.375 0.482442V2.09065C7.51228 2.12759 10 2.77432 10 5.83243C10 7.06674 9.22693 8.28953 8.3724 8.92883C8.10574 9.12834 7.7257 8.87794 7.82402 8.55455C8.70965 5.64136 7.40396 4.86797 4.375 4.82313V6.58927C4.375 7.00512 3.90039 7.22114 3.59986 6.95418L0.162283 3.90061C-0.0539478 3.70852 -0.0542407 3.36316 0.162283 3.17081Z"
		/>
	</svg>
)
